import { apiClient } from '../../../helpers/api_helper';

export const getAllCollectionData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetAllCollection`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllCollectionForSelect = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetCollectionSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getCollectionById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetCollectionDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createCollection = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Collection/InsertCollection', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateCollection = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Collection/UpdateCollection', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteCollection = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Collection/DeleteCollection?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};